<template lang="pug">
  v-row
    v-col
      h1.mb-3 Создание вебинара
      validation-observer(ref="obs" v-slot="{ invalid, passes, pristine, validate, validated }")
        v-form
          validation-provider(
            rules="required"
            name="Заголовок"
            vid="title"
            v-slot="{ errors, valid }"
          )
            v-text-field(
              v-model="title"
              name="title"
              label="Заголовок"
              :error-messages="errors"
              filled
              rounded
            )
          validation-provider(
            name="Описание"
            vid="description"
            v-slot="{ errors, valid }"
          )
            v-textarea(
              v-model="description"
              name="description"
              label="Описание"
              :error-messages="errors"
              filled
              rounded
            )
          validation-provider(
            rules="required"
            name="Вид деятельности"
            vid="type_activity"
            v-slot="{ errors, valid }"
          )
            activity-select(
              v-model="typeActivity"
              :errors="errors"
            )

          validation-provider(
            :rules="{ regex: YOUTUBE_REGEX_VALIDATION, required: true }"
            name="Ссылка на видео"
            vid="video_link"
            v-slot="{ errors, valid }"
          )
            v-text-field(
              v-model="videoLink"
              name="video_link"
              label="Ссылка на видео"
              :error-messages="errors"
              filled
              rounded
            )

          // Изображение
          image-upload(
            ref="imageUploader"
            vid="img"
            name="Изображение"
            :existing-image-url="oldImage"
          )

          sdo-back-button
          v-btn(
            @click="validateData"
            color="success"
            :loading="loadingBtn"
            depressed rounded
          )
            | {{ $route.meta.update ? 'Обновить вебинар' : 'Добавить вебинар' }}

</template>

<script>
import VueCropper from 'vue-cropperjs';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cropperjs/dist/cropper.css';

import ActivitySelect from '@/components/InputFields/course/SelectActivity.vue';
import WebinarService from '@/services/API/WebinarService';
import ImageUpload from '@/components/InputFields/ImageUpload.vue';

const YOUTUBE_REGEX_VALIDATION = '^(?:https?:\\/\\/)?(?:m\\.|www\\.)?(?:youtu\\.be\\/|youtube\\.com\\/(?:embed\\/|v\\/|watch\\?v=|watch\\?.+&v=))((\\w|-){11})(\\?\\S*)?$';

export default {
  name: 'WebinarCreate',
  components: { ImageUpload, ActivitySelect, VueCropper },
  data: () => ({
    title: '',
    description: '',
    typeActivity: null,
    videoLink: '',
    image: '',
    oldImage: '',
    loadingBtn: false,
    YOUTUBE_REGEX_VALIDATION,
  }),
  mounted() {
    if (this.$route.meta.update) {
      this.loadWebinar();
    }
  },
  methods: {
    validateData() {
      this.$refs.obs.validate()
        .then((valid) => {
          if (!valid) {
            this.$toasted.error('Не пройдена валидация', { duration: 2000 });
            return;
          }
          this.saveWebinar();
        });
    },
    async saveWebinar() {
      this.loadingBtn = true;

      try {
        const data = {
          title: this.title,
          description: this.description,
          type_activity: this.typeActivity,
          video_link: this.videoLink,
        };
        // Если есть изображение - загружаем на сервер и указываем имя
        try {
          const img = await this.$refs.imageUploader.uploadFile();
          if (img) data.img = img;
        } catch (e) {
          console.log('Ошибка в WebinarCreate', e);
          this.loadingBtn = false;
        }

        if (!this.$route.meta.update) {
          this.$rHandler(
            WebinarService.createWebinar(data),
            () => {
              this.$toasted.success('Вебинар успешно добавлен', {
                duration: 2000,
                icon: 'mdi-check',
              });
              this.$router.go(-1);
              this.loadingBtn = false;
            },
            () => {
              this.loadingBtn = false;
            },
            this.$refs.obs,
          );
        } else {
          this.$rHandler(
            WebinarService.updateWebinar(this.$route.params.id, data),
            () => {
              this.$toasted.success('Вебинар успешно обновлен', {
                duration: 2000,
                icon: 'mdi-check',
              });
              this.$router.go(-1);
              this.loadingBtn = false;
            },
            () => {
              this.loadingBtn = false;
            },
            this.$refs.obs,
          );
        }
      } catch (e) {
        console.error('Произошла ошибка при сохранении: ', e);
        this.$toasted.error('Произошла ошибка при сохранении');
        this.loadingBtn = false;
      }
    },
    loadWebinar() {
      this.$rHandler(
        WebinarService.getWebinar(this.$route.params.id),
        (r) => {
          this.title = r.data.data.title;
          this.description = r.data.data.description;
          this.typeActivity = r.data.data.type_activity.id;
          this.videoLink = r.data.data.video_link;
          this.oldImage = r.data.data.img;
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  .preview {
    width: 100%;
    height: calc(378px * (225 / 378));
    overflow: hidden;
    border: 1px solid #aaa;
  }

</style>
